import { IStatus } from '..';

export const getTips = (status: IStatus, sceneId: string) => {
  let tips = ['数据正在初始化...', '完成后点击【确定】按钮，将开始智能创作'];
  if (status === IStatus.START) {
    tips = ['数据正在初始化...', '完成后点击【确定】按钮，将开始智能创作'];
  }
  if (status === IStatus.SUCCESS && sceneId) {
    tips = ['数据初始化成功', '点击【确定】按钮，将开始智能创作'];
  }
  if (status === IStatus.FAIL) {
    tips = ['数据初始化失败', '请点击【重试】按钮'];
  }
  return tips;
};
